import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import JudgeNav from './nav/JudgeNav';
import useLayout from 'hooks/useLayout';
import useCustomLayout from 'hooks/useCustomLayout';
import { useWindowSize } from 'hooks/useWindowSize';
import { MENU_BEHAVIOUR, MENU_PLACEMENT } from 'constants.js';
import useMenuStatusWatcher from 'hooks/useMenuStatusWatcher';
import { ToastContainer } from 'react-toastify';

const LayoutJudgePortal = ({
  children,
  judgeView = 'home',
  headerState = '',
}) => {
  useLayout();
    useMenuStatusWatcher();

  useCustomLayout({
    useSidebar: false,
    placement: MENU_PLACEMENT.Horizontal,
    behaviour: MENU_BEHAVIOUR.Pinned,
  });

  // @ts-ignore
  const { themeValues } = useSelector((state) => state.settings);

  const lgBreakpoint = parseInt(themeValues?.lg?.replace('px', '') || '992', 10);
  const { width } = useWindowSize();

  const [isLgScreen, setIsLgScreen] = useState(false);
  const [isOpenFiltersModal, setIsOpenFiltersModal] = useState(false);

  const { pathname } = useLocation();

  useEffect(() => {
    if (!width) return;

    if (width >= lgBreakpoint) {
      if (!isLgScreen) setIsLgScreen(true);
      if (isOpenFiltersModal) setIsOpenFiltersModal(false);
    } else if (isLgScreen) {
      setIsLgScreen(false);
    }

    // eslint-disable-next-line
  }, [width, lgBreakpoint]);

  useEffect(() => {
  const html = document.documentElement;

  // always set judge view
  html.setAttribute('data-judge', judgeView);

  // only set header if provided
  if (headerState) {
    html.setAttribute('data-header', headerState);
  } else {
    html.removeAttribute('data-header');
  }

  return () => {
    html.removeAttribute('data-judge');
    html.removeAttribute('data-header');
  };
}, [judgeView, headerState]);

  useEffect(() => {
    document.documentElement.click();
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <JudgeNav />

      <div className="judgePortal">
        <Container>
          <Row className="h-100">
            <Col className="h-100" id="contentArea">
              {children}
            </Col>
          </Row>
        </Container>
      </div>
          <ToastContainer />
    </>
  );
};

export default React.memo(LayoutJudgePortal);